module.exports = __webpack_public_path__ + "static/media/status-pending.e669eab0.svg";